import { Component, OnInit, Input, Output, SecurityContext, EventEmitter, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs/Observable';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { EmailDetailService } from '../../services/email-detail.service';
import { ApproveQService } from '../../services/approve-q.service';
import { AutomateJobService } from '../../services/automate-job.service';
import { ClassifierService } from '../../services/classifier.service';
import { AuthService } from '../../services/auth.service';
import { CacheService } from '../../global/ng2-cache/services/cache.service';
import { ErrorService } from '../../services/error.service';
import { GlobalMessageService } from '../../services/global-message.service';
import { ConfirmDialogComponent } from '../../global/confirm-dialog/confirm-dialog.component';
import { DriftService } from '../../services/drift.service';

import { Constants } from '../../global/constants';
import { SocketService } from '../../services/socket.service';
import { AdminOpsService } from 'app/services/admin/admin-ops.service';

@Component({
  selector: 'email-detail',
  templateUrl: './email-detail.component.html',
  styleUrls: ['./email-detail.component.scss']
})
export class EmailDetailComponent implements OnInit {

  @Input()
  edId: any = {};

  @Output('onBotStatusChange')
  onBotStatusChange: EventEmitter<any> = new EventEmitter<any>();

  @Output('onDelete')
  onDelete: EventEmitter<any> = new EventEmitter<any>();

  loadingDetail: boolean = false;

  ed: any = {};
  taskHistory: any[] = [];
  botMeta: any;
  botStatus: number = 0; // 0=none, 1=draft, 2=pending, 3=sent
  gptSummary: string

  // for bot/draft category change
  automateJob: any;
  classifier: any;
  botCategories: any[] = [];

  // Email modifications
  reportDialogRef: BsModalRef;
  typeDialogRef: BsModalRef;
  fwdDialogRef: BsModalRef;

  fwdRecipients:string = null;
  fwdNote: string = null;
  newType: string = '';

  report: any = {
    incorrectType: false,
    missingName: false,
    missingOther: false,
    invalidName: false,
    badAssociation: false,
    comments: ''
  };

  currentUserId: string;

  constructor(private authService: AuthService,
              private cacheService: CacheService,
              private errorService: ErrorService,
              private domSanitizer: DomSanitizer,
              private emailDetailService: EmailDetailService,
              private approveQService: ApproveQService,
              private automateJobService: AutomateJobService,
              private classifierService: ClassifierService,
              private modalService: BsModalService,
              private globalMessageService: GlobalMessageService,
              private driftService: DriftService,
              private cdRef: ChangeDetectorRef,
              private constants: Constants,
              private socketService: SocketService,
              private adminOpsService: AdminOpsService,
  ) { }

  ngOnInit() {
    this.socketService
      .getEmailDetailUpdate()
      .subscribe((data) => {
        if (this.ed._id == data.emailId) {
          // only refresh if the email is selected
          this.loadingDetail = true;
          this.initView();
          this.globalMessageService.message('Email was ' + data.botStatus + ' by another user');
        }
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.initView();
  }

  rerun() {
    let me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: 'Please confirm you would like to re-run this email through automate skills',
        confirm: () => {
          me.emailDetailService.rerun(me.ed._id).subscribe(
            (result: any) => {
              me.globalMessageService.message('Email was set for rerun');
              me.driftService.track('rerun-email');
            },
            (error) => {
              me.globalMessageService.error();
              me.errorService.log(error, 'inbox.component', 'rerun');
            }
          );
        }
      }
    }));
  }

  reportProblem(dialog) {
    this.reportDialogRef = this.modalService.show(dialog, { class: 'modal-lg' });
  }

  sendReport() {
    this.reportDialogRef.hide();
    this.initReport();
    let report: any = {
      user_id: this.currentUserId,
      name: this.cacheService.get('session').name,
      account_id: this.cacheService.get('session').account_id,
      account: this.cacheService.get('session').account,
      ed_id: this.ed._id,
      ce_id: this.ed.ce_id,
      detail: this.report
    };

    this.emailDetailService.reportQA(report).subscribe(
      (result: any) => {
        this.globalMessageService.message('Email was reported. Thank you!');
        this.driftService.track('reported-email');
      },
      (error) => {
        this.globalMessageService.error();
        this.errorService.log(error, 'inbox.component', 'reportProblem');
      }
    );
  }

  changeType(dialog) {
    this.typeDialogRef = this.modalService.show(dialog, { class: 'modal-md' });
  }

  changeTypeConfirm() {
    this.typeDialogRef.hide();
    this.initReport();
    this.report.incorrectType = true;
    this.report.comments = `User changed type from ${this.ed.type} to ${this.newType}`;
    let model = {
      user_id: this.currentUserId,
      name: this.cacheService.get('session').name,
      account_id: this.cacheService.get('session').account_id,
      account: this.cacheService.get('session').account,
      ed_id: this.ed._id,
      ce_id: this.ed.ce_id,
      type: this.newType,
      detail: this.report
    };
    this.emailDetailService.changeType(this.ed._id, model).subscribe(
      (result: any) => {
        this.initView();
        this.globalMessageService.message('Email type was changed');
        this.driftService.track('changed-emailtype');
      },
      (error) => {
        this.globalMessageService.error();
        this.errorService.log(error, 'inbox.component', 'changeType');
      }
    );
  }

  fwd(dialog) {
    this.fwdDialogRef = this.modalService.show(dialog, { class: 'modal-md' });
  }

  fwdConfirm() {
    this.fwdDialogRef.hide();
    if(!this.fwdRecipients){
      return;
    }
    this.emailDetailService.forward(this.edId,this.fwdNote, this.fwdRecipients.split(',')).subscribe(
      (result: any) => {
        this.globalMessageService.message('Email was forwarded');
        this.driftService.track('email-forward');
        this.fwdRecipients = null;
        this.fwdNote = null;
      },
      (error) => {
        this.globalMessageService.error();
        this.errorService.log(error, 'inbox.component', 'fwdEmail');
        this.fwdRecipients = null;
        this.fwdNote = null;
      }
    );
  }

  deleteEmail() {
    const me = this;
    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: 'Please confirm you would like to delete this email from your account',
        confirm: () => {
          const accountId = me.cacheService.get('session').account_id;
          me.emailDetailService.hide(me.ed._id, accountId).subscribe(
            () => {
              me.globalMessageService.message('Email was deleted');
              me.driftService.track('deleted-email');
              me.initView();
              me.onDelete.emit(true);
            },
            (error) => {
              me.globalMessageService.error();
              me.errorService.log(error, 'inbox.component', 'deleteEmail');
            }
          );
        }
      }
    }));
  }

  botStatusCustomer() {
    this.onBotStatusChange.emit('customer');
    this.globalMessageService.message('Moved to customer review');
    this.loadingDetail = true;
    this.initView();
  }

  botStatusDelete(historyItem: any) {
    this.onBotStatusChange.emit('deleted');
    this.globalMessageService.message('Draft was deleted');
    this.loadingDetail = true;
    this.initView();
    this.updateEmailDetail(this.edId, 'deleted');
  }

  botStatusApprove(historyItem: any) {
    this.onBotStatusChange.emit('pending');
    this.globalMessageService.message('Draft was approved and will send shortly');
    this.loadingDetail = true;
    this.initView();
    this.updateEmailDetail(this.edId, 'complete');
  }

  botCategoryChange(data: any) {
    this.approveQService.changeCategory(this.edId, data.bmItem.automate_job_id, data.categoryId).subscribe(
      (result: any) => {
        this.globalMessageService.message('Category was changed');
        this.loadingDetail = true;
        this.initView();
        this.updateEmailDetail(this.edId, 'changed', data.bmItem.automate_job_id, data.categoryId);
      },
      (e) => {
        // empty error
      }
    );
  }

  /**
   * Converts pending tasks for a skill back to draft state for edit/delete
   * @param bmItem
   */
  stopPending(bmItem: any) {
    let me = this;
    let respondQId = bmItem.respondQItem ? bmItem.respondQItem._id : null;
    let trackQId = bmItem.trackQItem ? bmItem.trackQItem._id : null;

    this.modalService.show(ConfirmDialogComponent, Object.assign({}, {
      initialState: {
        message: 'Please confirm you would like to stop pending tasks and convert to a draft.',
        confirm: () => {
          me.approveQService.stopPending(respondQId, trackQId).subscribe(
            (result: any) => {
              me.onBotStatusChange.emit('draft');
              me.globalMessageService.message('Pending tasks were converted to a draft');
              me.loadingDetail = true;
              me.initView();
            },
            (error) => {
              me.globalMessageService.error();
            }
          );
        }
      }
    }));
  }

  private cleanHtml() {
    let markup = this.ed.customer_email.text
        .trim()
        .replace(/<mailto:(.{0,25}[@]).{0,40}>/g, ' ')  // these are hidden from parsing, hide them from the interface
        .replace(/[<>]+/g, ' ')                         // emails are sometimes hidden between these, dump them
        .replace(/\n/g, '<br />')                       // replace line feeds with break tags to preserve format for display
        .replace(/[\s]+/g, ' ');                        // replace all whitespace with a single space
    return markup + '<br/>';
  }

  private addHighlights() {
    let highlight = this.ed.clean;
    // sort people by length of title. This is to make sure that supersets of titles get highlighted
    // correctly. Otherwise "Assistant" gets highlighted twice when there's also "Assistant Director of Marketing"
    this.ed.contacts.sort((a, b) => {
      if (a.title && a.title.length > b.title.length) {
          return -1;
      }
      else {
          return 1;
      }
    });

    // this.ed.parsed_dates.forEach((d) => {
    //   var dRE = new RegExp(d.original.replace(/[+.()]/g, '\\$&'), 'gi');
    //   highlight = highlight.replace(dRE, '<span class="highlight h-date">' + d.original + '</span>');
    // });

    this.ed.contacts.forEach((p) => {
      let safeEmail= p.email_address.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      let eRE = new RegExp(safeEmail, 'gi');
      highlight = highlight.replace(eRE, '<span class="highlight h-email">' + p.email_address + '</span>');

      if (p.name.indexOf('@') < 0) { // otherwise email alias is overwritten by name
        let safeName = p.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape special characters for regex
        let nRE = new RegExp(safeName, 'gi');
        highlight = highlight.replace(nRE, '<span class="highlight h-name">' + p.name + '</span>');
      }

      if (p.phone_number && p.phone_number.length > 0) {
        let pRE = new RegExp(p.phone_number.replace(/[+.()]/g, '\\$&'), 'gi');
        // var pRE = new RegExp(p.phone_number, 'gi');
        highlight = highlight.replace(pRE, '<span class="highlight h-phone">' + p.phone_number + '</span>');
      }

      if (p.title && p.title.length > 0) {
        let safeTitle = p.title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); // escape special characters for regex
        let tRE = new RegExp(safeTitle, 'gi');
        highlight = highlight.replace(tRE, '<span class="highlight h-title">' + p.title + '</span>');
      }
    });
    return highlight;
  }

  private async initView() {
    this.loadingDetail = true;
    this.botStatus = 0;

    this.currentUserId = await this.authService.getCurrentUserId();
    Observable.forkJoin(
      this.emailDetailService.getFullEmail(this.edId)
    ).subscribe(
      (results: any) => {
        this.ed = results[0];
        this.taskHistory = this.ed.atHistory;
        this.botMeta = this.ed.botMeta || [];
        this.gptSummary = this.ed.gpt_summary || "";
        if (this.botMeta.length > 0) {
          this.resolveBotCategories();
        }

        let botEvent = this.ed.atHistory.find((ath) => ath.job_type == 'botevent' && ath.type == 'respond');
        if (botEvent) {
          if (botEvent.meta.action == 'pending') {
            this.botStatus = 2;
          }
          else if (botEvent.meta.action == 'send') {
            this.botStatus = 3;
          }
        }
        else if (this.botMeta) {
          this.botStatus = 1;
        }

        this.botMeta.forEach((bm) => {
          if (bm.respondQItem) {
            bm.respondQItem.meta.email.displayHtml = this.domSanitizer.sanitize(SecurityContext.HTML, bm.respondQItem.meta.email.html);
          }
        });

        let extractInsertion: number = 0;
        this.taskHistory.forEach((th) => {
          if (th.type == 'respond') {
            extractInsertion = 1;
            th.meta.email.displayHtml = this.domSanitizer.sanitize(SecurityContext.HTML, th.meta.email.html);
          }
        });

        this.ed.atHistory.sort((a, b) => {
          if (a.type == 'respond') {
            return -1;
          }
          else {
            return 1;
          }
        });

        // add extraction details to history for rendering, beginning of array unless there is a bot email to display
        if (this.ed.contacts.length > 0) {
          this.taskHistory.splice(extractInsertion, 0, {
            type: 'extract',
            updated_at: this.ed.created_at,
            count: this.ed.contacts.length,
            showDetail: false,
            detail: this.ed.contacts
          });
        }

        this.ed.clean = this.cleanHtml();
        this.ed.highlight = this.domSanitizer.sanitize(SecurityContext.HTML, this.addHighlights());
        this.ed.typeDisplay = this.constants.emailTypes.find((ct) => {
          return ct.typeName == this.ed.type;
        }).display;
        this.loadingDetail = false;
        this.cdRef.detectChanges();
      },
      (e) => {
        // TODO
        throw e;
      }
    );
  }

  private resolveBotCategories() {
    // TODO: assumes only one bot / match. Needs work if/when there are more than 1
    Observable.forkJoin(
      this.automateJobService.getJob(this.botMeta[0].automate_job_id),
      this.classifierService.getClassifierForCategory(this.botMeta[0].categoryId)
     ).subscribe(
      (result: any) => {
        this.automateJob = result[0];
        this.classifier = result[1];
        this.botCategories = this.classifier.training.nb.category;
       },
       (e) => {
        // TODO
       }
     );
  }

  private initReport() {
    this.report = {
      incorrectType: false,
      missingName: false,
      missingOther: false,
      invalidName: false,
      badAssociation: false,
      comments: ''
    };
  }

  updateEmailDetail(emailDetailId, botStatus, automateJobId: string = null, categoryId: string = null) {
    let data: any = {};
    data.emailId = emailDetailId;
    data.botStatus = botStatus;

    if (automateJobId) {
      data.automateJobId = automateJobId;
    }
    if (categoryId) {
      data.categoryId = categoryId;
    }

    this.socketService.sendEmailDetailUpdate(data);
  }

  markGolden(type) {
    this.adminOpsService.addToGoldenset(this.edId, type, '').subscribe(
      () => {
        this.globalMessageService.message(`Email added to golden set for ${type}`);
      },
      (error) => {
        this.globalMessageService.error('Failed to add to the goldenset.');
        this.errorService.log(error, 'email-detail.component', 'goldenset');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./client/app/inbox/email-detail/email-detail.component.ts